import { FormField } from '../../../../../models/form-builder/form-field.model';
import { IFormFieldConstraint, IFormFieldConstraintWithMetrics } from '../../../../../interfaces/iform-field-constraint.interface';
import { CachedFormFieldService } from '../../../../../services/form-field-with-cache.service';
import { IFormFieldConstraintLiaison } from './ifield-constraint-liason.interface';
import { FieldConstraintLiaisonBase } from './field-constraint-liaison-base';
import { SiteFormFieldConstraintProperties } from '../../../../../models/form-builder/field-constraints/site-form-field-constraint-props.model';
import { DropDownFieldType, RadioButtonsFieldType } from '../../../../../models/form-builder/form-field-types';
import { FormFieldConstraintTypeEnum, FormFieldConstraintTypeForUsersEnum } from '../../../../../enums/form-field-constraint-type.enum';
import { FormFieldListValuesConstraint, FormFieldListValuesConstraintWithMetrics } from '../../../../../models/form-builder/field-constraints/form-field-list-values-constraint.model';

export class FormFieldCascadingListValueConstraintLiaison extends FieldConstraintLiaisonBase implements IFormFieldConstraintLiaison {
    // Constructor.
    public constructor() {
        super();
    }

    // Implement IFormFieldConstraintLiaison.
    // Getter/setter-like methods.
    public constraintTypeForEndUser(): string {  // A user-friendly constraint type name.
        return FormFieldConstraintTypeForUsersEnum.CascadingListValues;
    }

    public managesConstraintsOfType(): string {
        return FormFieldConstraintTypeEnum.CascadingListValues;
    }

    public getPrimaryPropertyName(): string {
        //return 'jsonConfig'; // Yes, I am reusing the existing 'selectOptions' FormField property.
        return 'selectOptionsFile'; // This is the name of the property for loading a file that contains a cascading-dropdown field's configuration.
    }

    public getConstraintId(formField: FormField): number {
        return formField.listValuesConstraintId;
    }
    public setConstraintId(formField: FormField, value: number): void {
        formField.listValuesConstraintId = value;
    }

    public getConstraintName(formField: FormField): string {
        //return formField.listValuesConstraintName;
        return formField.cascadingDropdownConstraintName;
    }
    public setConstraintName(formField: FormField, value: string): void {
        formField.listValuesConstraintName = value;
    }

    public getConstraintValue(formField: FormField): string {
        return formField.cascadingListValuesConstraintValue;
    }
    public setConstraintValue(formField: FormField, value: string): void {
        formField.cascadingListValuesConstraintValue = value;
    }

    // not relevant for this field type
    public getConstraintFailureMessage(formField: FormField): string {
        return null;
    }
    public setConstraintFailureMessage(formField: FormField, value: string): void {
        // noop
    }

    public getConstraintFormFieldPropertyValue(formField: FormField): string {
        return formField.csvOptionsData?.rawCsv;
    }

    public copyConstraintValueToCorrespondFormFieldProperty(formField: FormField, value: string): void {
        formField.jsonConfig = value;
    }

    // Create a new, empty constraint.
    public createNewConstraint(dataCollectionId: number): IFormFieldConstraintWithMetrics {
        //let newConstraint: FormFieldListValuesConstraintWithMetrics = new FormFieldListValuesConstraintWithMetrics(dataCollectionId);
        let newConstraint: FormFieldListValuesConstraintWithMetrics = FormFieldListValuesConstraintWithMetrics.createCascadingListValuesConstraintFrom(dataCollectionId);
        //newConstraint.constraintType = FormFieldConstraintTypeEnum.CascadingListValues;
        return newConstraint;
    }

    public createNewConstraintFrom(constraintParam: IFormFieldConstraint): IFormFieldConstraintWithMetrics {
        let constraint = <FormFieldListValuesConstraint>constraintParam;
        //let newConstraint = new FormFieldListValuesConstraintWithMetrics(constraint.dataCollectionId, constraint.id, constraint.name, constraint.constraintExpression);
        let newConstraint = FormFieldListValuesConstraintWithMetrics.createCascadingListValuesConstraintFrom(constraint.dataCollectionId, constraint.id, constraint.name, constraint.constraintExpression);
        return newConstraint;
    }

    // Package constraint values as a constraint.
    public packageConstraint(dataCollectionId: number, formField: FormField): IFormFieldConstraint {
        //let packagedConstraint = new FormFieldListValuesConstraint(dataCollectionId, formField.selectOptionsConstraintId, formField.selectOptionsConstraintName, formField.selectOptionsConstraintValue);
        let packagedConstraint = FormFieldListValuesConstraint.createCascadingListValuesConstraintFrom(dataCollectionId, formField.selectOptionsConstraintId, formField.selectOptionsConstraintName, formField.selectOptionsConstraintValue);

        return packagedConstraint;
    }
    public updateOrCreateConstraint(cachedFormFieldService: CachedFormFieldService, updatedConstraintParam: IFormFieldConstraint): void {
        let updatedConstraint: FormFieldListValuesConstraint = <FormFieldListValuesConstraint>updatedConstraintParam;
        cachedFormFieldService.updateOrCreateCascadingListValuesConstraint(updatedConstraint);
    }

    // Methods related to applying form field constraint
    // updates to a form field that uses the same constraint.
    public get createNamedConstraintMethodName(): string {
        return 'createCascadingListValuesConstraint';
    }
    public get updateNamedConstraintMethodName(): string {
        return 'updateCascadingListValuesConstraint';
    }
    public get updateOrCreateNamedConstraintMethodName(): string {
        return 'updateOrCreateCascadingListValuesConstraint';
    }
    public get siteNamedConstraintsMethodName(): string {
        return 'getSiteNamedCascadingListValueConstraints';
    }

    public get usedByFormFieldClasses(): string[] {
        return [DropDownFieldType, RadioButtonsFieldType];
    }

    public applyConstraintPropertiesToFormField(constraint: IFormFieldConstraint, formField: FormField) {
        formField.listValuesConstraintId = constraint.id;
        formField.cascadingDropdownConstraintName = constraint.name;
        formField.cascadingListValuesConstraintValue = constraint.constraintExpression;
        formField.selectOptions = constraint.constraintExpression;
    }

    // A method to create a constraint from the results of an all site named constraints query.
    public createFromConstraintProperties(dataCollectionId: number, constraintProperties: SiteFormFieldConstraintProperties): IFormFieldConstraintWithMetrics {
        //let constraint: FormFieldListValuesConstraintWithMetrics = new FormFieldListValuesConstraintWithMetrics(dataCollectionId, constraintProperties.constraintId, constraintProperties.constraintName, constraintProperties.jsonConfig);
        let constraint: FormFieldListValuesConstraintWithMetrics = FormFieldListValuesConstraintWithMetrics.createCascadingListValuesConstraintFrom(dataCollectionId, constraintProperties.constraintId, constraintProperties.constraintName, constraintProperties.jsonConfig);
        constraint.useCount = constraintProperties.useCount;
        return constraint;
    }
}
